import { get } from './fetch'

export const getNfts = (data = {}) => get('/v1/get_nfts', data)

export const getContract = (data = {}) => get('/v1/get_contract', data)
